import { TransferOrderStatus } from '../constants/transfer-order-status.js';
export const TRANSFER_ORDER_UNSHIPPED_OPEN_STATUS_IDS = [
    TransferOrderStatus.ISSUED,
    TransferOrderStatus.PICK,
];
//# sourceMappingURL=transfer-order-unshipped-open-status-ids.js.map